import {inject, Injectable} from "@angular/core";
import {Router} from "@angular/router";
import {GroupItemModel} from "../../../shared/modules/loren-hierarchy-selector/group.interface";
import {LorenGroupService} from "../services/loren-group-service/loren-group.service";
import {BaseEntitiesResolver} from "../../../shared/resolvers/loren-base-entities-resolver/base-entities.resolver";
import {map} from "rxjs/operators";

@Injectable()
export class LorenAllGroupsResolver extends BaseEntitiesResolver<GroupItemModel> {
    protected service = inject(LorenGroupService);
    protected router = inject(Router);

    resolve() {
        return this.service.query().pipe(map((res) => res.items));
    }
}
